import {Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalService} from './modal.service';


@Component({
    selector: 'app-modal',
    template: `
        <div class="modal-dialog" style="z-index: 1; position: relative;">
            <div class="modal-content">
                <div class="modal-body">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" style="z-index: 0" (click)="close()"></div>
    `,
    styles: [`
    :host {
        z-index: 99999;
        padding-right: 17px;
    }
    `]
})

export class ModalComponent implements OnInit, OnDestroy {
    @Input() id!: string;
    private element: any;
    private readonly onBackgroundClick = (e: MouseEvent) => {
        if ((e.target as HTMLElement).className === 'modal') {
            this.close();
        }
    };

    constructor(private modalService: ModalService, private el: ElementRef) {
        this.element = el.nativeElement;
    }

    ngOnInit(): void {
        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        this.element.addEventListener('click', this.onBackgroundClick);
        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when directive is destroyed
    ngOnDestroy(): void {
        this.element.removeEventListener('click', this.onBackgroundClick);
        this.modalService.remove(this.id);
        this.element.remove();
    }

    // open modal
    open(): void {
        this.modalService.add(this);
        this.element.style.display = 'block';
        document.body.style.paddingRight = '17px';
        document.body.classList.add('modal-open');
        document.body.classList.add('unsubscribe');
    }

    // close modal
    close(): void {
        this.element.style.display = 'none';
        document.body.style.paddingRight = '0';
        document.body.classList.remove('modal-open');
    }
}
